import NotFound from '../../../images/not_found.svg'
const NoData = () => (
  <div className="my-12">
     <img src={NotFound} className="w-12 mx-auto opacity-20" alt="not found data"/>
    <div className="text-md text-center font-semibold mt-4 text-[#E5E6E6]">No Data</div>
  </div>
);

export default NoData;